import { render, staticRenderFns } from "./circle_icon.vue?vue&type=template&id=aaaed034&scoped=true"
import script from "./circle_icon.vue?vue&type=script&lang=js"
export * from "./circle_icon.vue?vue&type=script&lang=js"
import style0 from "./circle_icon.vue?vue&type=style&index=0&id=aaaed034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaed034",
  null
  
)

export default component.exports